import { useState, useCallback } from 'react';
import axios from 'axios';
import { useToast } from '../../../contexts/ToastContext';

export const useADSBServiceBulletins = () => {
  const [bulletins, setBulletins] = useState([]);
  const [aircraft, setAircraft] = useState([]);
  const [assemblies, setAssemblies] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();

  const fetchBulletins = useCallback(async (filters = {}) => {
    setLoading(true);
    try {
      const params = {};
      if (filters.classification && filters.classification !== 'ALL') params.classification = filters.classification;
      if (filters.priority && filters.priority !== 'ALL') params.priority = filters.priority;
      if (filters.source && filters.source !== 'ALL') params.source = filters.source;
      if (filters.regulatoryAuthority && filters.regulatoryAuthority !== 'ALL') {
        params.regulatoryAuthority = filters.regulatoryAuthority;
      }
      if (filters.statusFilter && filters.statusFilter !== 'ALL') params.statusFilter = filters.statusFilter;
      if (filters.bulletinTypeFilter && filters.bulletinTypeFilter !== 'ALL') {
        params.bulletinTypeFilter = filters.bulletinTypeFilter;
      }
      if (filters.aircraftId && filters.aircraftId !== 'ALL') params.aircraftId = filters.aircraftId;
      if (filters.assemblyId && filters.assemblyId !== 'ALL') params.assemblyId = filters.assemblyId;
      const response = await axios.get('/api/adsb-service-bulletins', { params });
      setBulletins(response.data);
    } catch (error) {
      console.error('Error fetching AD/SB bulletins:', error);
      showToast('Failed to fetch AD/SB bulletins', 'error');
    } finally {
      setLoading(false);
    }
  }, [showToast]);

  const fetchAircraft = useCallback(async () => {
    try {
      const response = await axios.get('/api/aircraft');
      setAircraft(response.data);
    } catch (error) {
      console.error('Error fetching aircraft:', error);
    }
  }, []);

  const fetchAssemblies = useCallback(async (aircraftId) => {
    try {
      const params = { isActive: 'true' };
      if (aircraftId && aircraftId !== 'ALL') params.aircraftId = aircraftId;
      const response = await axios.get('/api/assemblies', { params });
      const list = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      list.sort((a, b) => {
        const la = `${a.typeName || ''} ${a.serialNumber || ''}`.toLowerCase();
        const lb = `${b.typeName || ''} ${b.serialNumber || ''}`.toLowerCase();
        return la.localeCompare(lb);
      });
      setAssemblies(list);
    } catch (error) {
      console.error('Error fetching assemblies:', error);
      setAssemblies([]);
    }
  }, []);

  return { bulletins, aircraft, assemblies, loading, fetchBulletins, fetchAircraft, fetchAssemblies, setBulletins };
};
